<div class="flex flex-col flex-grow h-full">
  <div id="editingContainer" class="flex flex-col pt-2.5 p-5 h-full flex-grow">
    <div class="flex flex-row items-center justify-between">
      <div class="flex flex-row justify-between items-center pt-2.5 pb-2.5 w-full">
        <div class="flex flex-row items-center buttonContainer">
          <button mat-icon-button
                  (click)="onBack()">
            <mat-icon svgIcon="arrow_back"></mat-icon>
          </button>
          <span>
          {{
              isNew() ?
                  (settingType() === AiSettingsType.GREETING ? ('REVIEWS.NEW_GREETING' | translate)
                      :
                      ('REVIEWS.NEW_CLOSING' | translate))
                  :
                  (settingType() === AiSettingsType.GREETING ? ('REVIEWS.EDIT_GREETING' | translate)
                      :
                      ('REVIEWS.EDIT_CLOSING' | translate))
            }}
        </span>
        </div>

        <div class="flex justify-content: flex-end buttonContainer">
          @if (!isNew()) {
            @if (deletionInProgress()) {
              <div class="spinner-container">
                <mat-spinner [diameter]="20"></mat-spinner>
              </div>
            }
            <button mat-icon-button
                    [disabled]="savingInProgress() || deletionInProgress()"
                    matTooltip="{{'DELETE' | translate}}"
                    (click)="onDelete()">
              <mat-icon svgIcon="delete_outline"></mat-icon>
            </button>
          }
        </div>
      </div>
    </div>

    <div>
      <form [formGroup]="formGroup">
        <mat-form-field id="templateNameForm"
                        appearance="fill"
                        (clickOutside)="wasTemplateNameTooLong.set(false)">
          <input matInput appGxInput
                 formControlName="templateName"
                 placeholder="{{'REVIEWS.TEMPLATES.GREETING_CLOSING_TITLE_PLACEHOLDER' | translate }}">
          @if (formGroup?.controls?.templateName?.errors?.duplicateName) {
            <mat-hint class="mat-error">
              {{ 'REVIEWS.TEMPLATES.ERROR_DUPLICATE_TITLE' | translate }}
            </mat-hint>
          }
          <mat-hint [ngClass]="{'mat-error' : wasTemplateNameTooLong()}"
                    align="end">{{
              formGroup.controls.templateName.value
                  ? formGroup.controls.templateName.value.length : 0
            }}
            / {{ nameMaxLength }}
          </mat-hint>
        </mat-form-field>

        <quill-editor #quillEditor
                      formControlName="templateObject"
                      [modules]="quillModules"
                      format="object"
                      theme="bubble"
                      [formats]="['mention']"
                      trackChanges="all"
                      placeholder="{{ settingType() === AiSettingsType.GREETING ? ('REVIEWS.TEMPLATES.GREETING_TEXT_PLACEHOLDER' |translate) : ('REVIEWS.TEMPLATES.CLOSING_TEXT_PLACEHOLDER' | translate) }}">
        </quill-editor>

        <app-emoji-picker
            (emojiSelected)="insertEmoji($event, quillEditor)"></app-emoji-picker>

        <div align="end"
             class="matHint"
             [ngClass]="{'matError' : formGroup.controls.templateText.invalid}">
          {{
            formGroup.controls.templateText.value
                ? formGroup.controls.templateText.value.length : 0
          }}
          / {{ textMaxLength }}
        </div>

        <div id="tagToolbar" class="flex flex-col">
          <div id="tagToolbarHeader" class="flex flex-row items-center">
            <span class="text-neutral-10">{{ "REVIEWS.TEMPLATES.PERSONALISATION_TAGS" | translate }}</span>
            <button mat-icon-button
                    [matMenuTriggerFor]="infoMenu"
                    [ngClass]="{infoMenuOpened: infoMenuOpened()}"
                    (menuOpened)="onInfoMenuOpened()">
              <mat-icon svgIcon="help_outline"></mat-icon>
            </button>
          </div>
          <div class="flex flex-row">
            <mat-chip-set>
              @for (tag of tagList; track tag) {
                <mat-chip (click)="insertNameTag(tag)">
                  <div class="flex items-center">
                    <mat-icon svgIcon="add"></mat-icon>
                    {{ tag.value }}
                  </div>
                </mat-chip>
              }
            </mat-chip-set>
          </div>
        </div>


        <mat-menu #infoMenu="matMenu"
                  yPosition="below"
                  (closed)="onInfoMenuClosed()"
                  class="infoMenu">
          <p><b>{{ "REVIEWS.TEMPLATES.PERSONALISATION_TAGS" | translate }}</b></p>
          <span>{{ "REVIEWS.TEMPLATES.PERSONALISATION_TAGS_TOOLTIP" | translate }}</span>
        </mat-menu>

      </form>


    </div>


  </div>
  <div class="flex flex-col flex-grow bottomPanel py-[10px] px-[20px]">
    <div class="flex flex-row items-center justify-end">

      <button class="mr-2" mat-button (click)="onCancel()"
              [disabled]="savingInProgress() || deletionInProgress()">{{ 'CANCEL' | translate }}
      </button>

      <div class="button-container">
        @if (savingInProgress()) {
          <div class="spinner-container">
            <mat-spinner [diameter]="20"></mat-spinner>
          </div>
        }
        <button mat-flat-button color="primary" (click)="onSave()"
                [disabled]="!canSubmit() || deletionInProgress() || savingInProgress()">
          <span>{{ 'SAVE' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
